import { css } from '@compiled/react';

import { ConfluenceOverlayTemplate } from '@/components/signup/layouts/product-overlay-template';
import { ReturnToProduct } from '@/components/signup/site-activation/components/common/return-to-product';
import { SiteActivation } from '@/components/signup/site-activation/site-activation';

import { Headings } from '../../../components/headings';
import { ReturnToProductText } from '../../../components/return-to-product-subheading';
import { WelcomeBackText } from '../../../components/welcome-back-heading';

export const CurrentProductUser = () => {
	return (
		<ConfluenceOverlayTemplate size="sm">
			<div css={containerCss}>
				<Headings main={<WelcomeBackText />} sub={<ReturnToProductText />} />
				<SiteActivation
					CurrentProductUser={<ReturnToProduct />}
					useContactExpandCohortLogic={true}
				/>
			</div>
		</ConfluenceOverlayTemplate>
	);
};

const containerCss = css({
	display: 'grid',
	gap: '10px',
});
